import { useMemo } from 'react';

import { COUNTRY_CODE_MAP } from '@shared-web/constants/country';
import { isProdApp } from '@shared-web/constants/env';
import { useFeatureControl } from '@shared-web/hooks/useFeatureControl';
import { useAuth } from '@shared-web/modules/auth';

export const HK_IP_WHITELIST: string[] = [
  '118.143.80.66',
  '42.200.158.123',
  '210.176.141.46',
  '208.127.160.211',
  '208.127.160.212',
  '134.238.2.45',
  '24.239.135.14',
  '24.239.135.15',
];

export type CountryStateType = Record<keyof typeof COUNTRY_CODE_MAP, boolean>;

export function useCountry() {
  const { userState } = useFeatureControl();
  const { isLogin } = useAuth();
  const countryCode = useMemo(() => userState?.countryCode ?? '', [userState]);
  const onboardingEntity = useMemo(
    () => userState?.onboardingEntity ?? '',
    [userState],
  );

  const countryState = useMemo(() => {
    const whiteIpList = isProdApp ? HK_IP_WHITELIST : [];
    const state = {
      isUS: false,
      isUK: false,
      isCA: false,
      isBR: false,
      isHK: false,
      isEEA: false,
      isLATAM: false,
      isAU: false,
      isRUS: false,
      isARE: false,
      isKOR: false,
      isSG: false,
      isCYM: false,
    };

    (
      Object.keys(COUNTRY_CODE_MAP) as Array<keyof typeof COUNTRY_CODE_MAP>
    ).forEach((key) => {
      if (key === 'isHK') {
        if (isLogin) {
          state[key] = COUNTRY_CODE_MAP[key].includes(onboardingEntity);
        } else {
          state[key] =
            COUNTRY_CODE_MAP[key].includes(countryCode) &&
            !whiteIpList.includes(userState?.ip ?? '');
        }
      } else if (key === 'isARE' || key === 'isCYM') {
        if (isLogin) {
          state[key] = COUNTRY_CODE_MAP[key].includes(onboardingEntity);
        } else {
          state[key] = COUNTRY_CODE_MAP[key].includes(countryCode);
        }
      } else {
        state[key] = COUNTRY_CODE_MAP[key].includes(countryCode);
      }
    });

    return state;
  }, [isLogin, onboardingEntity, countryCode, userState?.ip]);

  return { countryState, countryCode };
}
